import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_ai-notes-preview/artifacts/qfix72o2_Lumero_Logo_transparent_with_name-removebg-preview.png";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/forgot-password", { email }); } catch {}
    setSent(true);
  };

  return (
    <div className="min-h-screen bg-[#FAF9F6] flex items-center justify-center px-4" data-testid="forgot-password-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <Link to="/"><img src={LOGO_URL} alt="LumeroFlow" className="h-9 mx-auto mb-6" /></Link>
          <h1 className="text-2xl font-medium text-[#1A1B1A] mb-1" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Reset password</h1>
          <p className="text-sm text-[#757675]">We'll send you a reset link</p>
        </div>
        {sent ? (
          <div className="text-center">
            <div className="bg-[#205B5A]/5 border border-[#205B5A]/10 text-[#205B5A] text-sm px-4 py-4 rounded-xl mb-6">
              If an account exists with that email, a reset link has been sent.
            </div>
            <Link to="/app/login" className="text-sm text-[#205B5A] font-medium">Back to sign in</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-[#1A1B1A] mb-1.5">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email-input"
                className="w-full px-4 py-3 rounded-xl border border-[#1A1B1A]/10 bg-white text-sm text-[#1A1B1A] focus:outline-none focus:border-[#205B5A] focus:ring-1 focus:ring-[#205B5A] transition-colors"
                placeholder="you@clinic.com" />
            </div>
            <button type="submit" data-testid="forgot-submit-btn"
              className="w-full bg-[#205B5A] text-white py-3 rounded-full font-medium text-sm hover:bg-[#174544] transition-colors">
              Send reset link
            </button>
            <p className="text-center text-sm text-[#757675]">
              <Link to="/app/login" className="text-[#205B5A] font-medium">Back to sign in</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
